import React, { useEffect, useRef } from "react";
import ProfileTab from "./ProfileTab";
import ScheduleTab from "./ScheduleTab";
import PracticeAreasSection from "./PracticeAreasSection";
import ContentSourcesRedesign from "./ContentSourcesRedesign";
import ComplianceTab from "./ComplianceTab";
import FiltersTab from "./FiltersTab";
import NotificationsTab from "./NotificationsTab";
import WorkspacesTab from "./WorkspacesTab";
import BillingTab from "./BillingTab";
import AccountTab from "./AccountTab";

const BORDER = "rgba(0,0,0,0.1)";

function SectionHeader({ children }) {
  return (
    <div style={{ fontSize: 11, letterSpacing: "0.15em", color: "#999", textTransform: "uppercase", fontWeight: 600, marginBottom: 16, marginTop: 32, fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      {children}
    </div>
  );
}

function Divider() {
  return <div style={{ height: 1, background: BORDER, margin: "24px 0" }} />;
}

export default function SettingsPage({
  user, setUser, dashState, CATEGORIES,
  onNavigateTeam, onNavigateBilling, setToast, initialSection,
}) {
  const isWorkspaceMember = user?.is_workspace_member;
  const isWorkspaceAdmin = user?.is_workspace_admin;
  const isMemberRole = user?.workspace_role === "member";
  const hideBilling = isWorkspaceMember && (isMemberRole || !isWorkspaceAdmin);
  const billingRef = useRef(null);

  useEffect(() => {
    if (initialSection === "billing" && billingRef.current) {
      setTimeout(() => billingRef.current.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [initialSection]);

  return (
    <div className="fade-up" style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ fontSize: 22, fontWeight: 500, marginBottom: 4 }}>Settings</div>
      <div style={{ fontSize: 13, color: "#888", marginBottom: 8 }}>Manage your profile, content, and preferences.</div>

      {/* ── SECTION 1: PROFILE ── */}
      <SectionHeader>Profile</SectionHeader>
      <ProfileTab user={user} setUser={setUser} CATEGORIES={CATEGORIES} />

      <Divider />

      {/* ── SECTION 2: VOICE & CONTENT ── */}
      <SectionHeader>Scheduling & Content</SectionHeader>
      <ScheduleTab user={user} setUser={setUser} dashState={dashState} />
      <div style={{ marginTop: 20 }}>
        <PracticeAreasSection user={user} setUser={setUser} />
      </div>
      <div style={{ marginTop: 20 }}>
        <ContentSourcesRedesign user={user} setUser={setUser} CATEGORIES={CATEGORIES} />
      </div>
      <div style={{ marginTop: 20 }}>
        <FiltersTab user={user} onNavigateBilling={onNavigateBilling} />
      </div>
      <div style={{ marginTop: 20 }}>
        <ComplianceTab user={user} setUser={setUser} />
      </div>

      <Divider />

      {/* ── SECTION 3: NOTIFICATIONS ── */}
      <SectionHeader>Notifications</SectionHeader>
      <NotificationsTab user={user} setUser={setUser} />

      {/* ── SECTION 4: TEAMS ── */}
      <Divider />
      <SectionHeader>Teams</SectionHeader>
      <WorkspacesTab user={user} dashState={dashState} onNavigateTeam={onNavigateTeam} />

      {/* ── SECTION 5: BILLING (hidden for workspace members) ── */}
      {!hideBilling && (
        <div ref={billingRef}>
          <Divider />
          <SectionHeader>Billing</SectionHeader>
          <BillingTab user={user} dashState={dashState} setToast={setToast} />
        </div>
      )}

      <Divider />

      {/* ── ACCOUNT (danger zone) ── */}
      <SectionHeader>Account</SectionHeader>
      <AccountTab user={user} />
    </div>
  );
}
